import { ROLES_KEYS } from '@interfaces';

export const roleToPath = {
  [ROLES_KEYS.Admin]: 'management',
  [ROLES_KEYS.Team_Leader]: 'management',
  [ROLES_KEYS.Employee]: 'management',
  [ROLES_KEYS.Foreigner]: 'user-process',
  [ROLES_KEYS.Employer]: 'manager',
  [ROLES_KEYS.Field_Consultant]: 'management/visits-list',
};

export const highEmployeeRoles = [ROLES_KEYS.Admin, ROLES_KEYS.Team_Leader, ROLES_KEYS.Employee];
export const allEmployeeRoles = [
  ROLES_KEYS.Admin,
  ROLES_KEYS.Employee,
  ROLES_KEYS.Team_Leader,
  ROLES_KEYS.Field_Consultant,
];

export const ROLES_ALLOWED_TO_HAVE_FOREIGNERS = [ROLES_KEYS.Employee, ROLES_KEYS.Team_Leader];

export const ROLES_RESTRICTED_TO_SUPPORTED_COMPANIES = [
  ROLES_KEYS.Team_Leader,
  ROLES_KEYS.Employee,
  ROLES_KEYS.Field_Consultant,
];
